import Vue from 'vue'
import moment from 'moment'
import 'moment-timezone'

Vue.filter('numberWithCommas', function (value: any) {
    if (value || value === 0) {
        const parts = value.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
    }
})

Vue.filter('formatNumbers', function (value: any) {
    if (value) {
        const val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
})

Vue.filter('toCurrency', function (value, currency = 'usd') {
    if (typeof value !== 'number') {
        return value
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    })
    return formatter.format(value) + (currency === 'cad' ? 'CAD' : '')
})
Vue.filter('capitalizeAndRemoveUnderscores', function (value) {
    if (typeof value !== 'string') {
        return value
    }
    const arrayOfWords = value.split('_')
    if (!arrayOfWords.length) {
        return value
    }
    return arrayOfWords.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
})

/**
 * @param {string} value - date to be formatted
 * returns formatted date - Example -> 02-09-2023, 02:29:25 PM EST
 */
Vue.filter('formatDateTimeTimeZone12Hr', function (value: string, timezone: string) {
    if (value) {
        let dateTimeStr: string
        value.toString().indexOf('Z') === -1 ? dateTimeStr = value + 'Z' : dateTimeStr = value
        return new Date(dateTimeStr).toLocaleTimeString('en-us', {
            hour12: true,
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: timezone,
            timeZoneName: 'short'
        }).replaceAll('/', '-')
    }
})

Vue.filter('formatDateAndTime', function (value: string, timezone: string, format: string) {
  if (value) {
    const date = moment(value)
    const formatToUse = format !== '' ? format : 'MM/DD/YYYY hh:mm:ss A'
    if (timezone) {
      return date.tz(timezone).format(formatToUse)
    } else {
      return date.format(formatToUse)
    }
  }
})

Vue.filter('pluralizeIfNecessary', function (singular: string, count: number, plural?: string): string {
    count = parseFloat(count as unknown as string)

    // Use the provided plural form if available
    if (plural) {
        return count === 1 ? singular : plural
    }

    // Apply basic pluralization rules for English
    if (count !== 1) {
        // Basic rule: add 's'
        if (!singular.toLowerCase().endsWith('s')) {
            // Handle words ending in 's', 'x', 'z', 'ch', 'sh' by adding 'es'
            if (singular.toLowerCase().endsWith('s') || singular.toLowerCase().endsWith('x') || singular.toLowerCase().endsWith('z') || singular.toLowerCase().endsWith('ch') || singular.toLowerCase().endsWith('sh')) {
                return singular + 'es'
            }

            // Handle words ending in consonant + 'y' by changing 'y' to 'ies'
            const lastChar = singular.slice(-1).toLowerCase()
            const secondLastChar = singular.slice(-2, -1).toLowerCase()
            const vowels = ['a', 'e', 'i', 'o', 'u']
            if (lastChar === 'y' && !vowels.includes(secondLastChar)) {
                return singular.slice(0, -1) + 'ies'
            }

            // Default to adding 's'
            return singular + 's'
        }
    }

    return singular
})

